import { InitStore } from './Stores/init-store';
import { Store } from './Stores/store';

export function isNullOrUndefined(value: unknown): boolean {
  return value === undefined || value === null;
}

export function getPhoneWaitingTime(): number | undefined {
  const contactType = Store?.get('messageData').contact_type || 'average';
  const time = InitStore?.get('init')?.phone.approximate_waiting_time;
  return time?.[contactType] || time?.average;
}
